<template>
  <q-select label="Sort By" v-model="sort_option" :options="sort_options" @update:model-value="changed"></q-select>
</template>

<script>
import SortOptions from "src/composables/SortOptions";

export default {
  name: "SortOptionSelect",
  setup(props, { emit }) {

    const changed = function () {
      emit('changed')
    }

    const { sort_options, sort_option } = SortOptions();
    return {
      sort_option,
      sort_options,
      changed
    }
  }
}
</script>

<style scoped>

</style>
